const $countContainer = document.querySelectorAll(".js-count-container");

if ($countContainer) {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const count = entry.target.querySelector(".js-count");
            
            if (entry.isIntersecting) {
                count.classList.add("animation");
                return;
            }
            
            count.classList.remove("animation");
        });
    });
    
    $countContainer.forEach(container => {
        observer.observe(container);
    });
}
